export const KSEF_ROUTES = {
  INVOICES_PURCHASE: {
    path: '/ksef/invoices/purchase',
    name: 'ksef-invoices-purchase',
  },
  INVOICES_SALE: {
    path: '/ksef/invoices/sell',
    name: 'ksef-invoices-sell',
  },
  INVOICES_PURCHASE_AUDIT_LOG: {
    path: '/ksef/invoices/purchase/:id/history',
    name: 'ksef-invoices-purchase-audit-log',
  },
  INVOICES_SALE_AUDIT_LOG: {
    path: '/ksef/invoices/sell/:id/history',
    name: 'ksef-invoices-sell-audit-log',
  },
  ARCHIVED_INVOICES_PURCHASE_AUDIT_LOG: {
    path: '/archive/ksef/invoices/purchase/:id/history',
    name: 'archived-ksef-invoices-purchase-audit-log',
  },
  ARCHIVED_INVOICES_PURCHASE: {
    path: '/archive/ksef/invoices/purchase',
    name: 'archived-ksef-invoices-purchase',
  },
};
